import { useQuery } from "react-query";
import { apiClient } from "../../base/ApiClient";
import { QK } from "../../base/qk";

// api to get form id
const getFormId = async (name) => {
  try {
    const response = await apiClient.get(`/form/form_id/?form_name=${name}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form ID:", error.response?.data || error.message);
    throw error;
  }
};

// custom hooks
export const useFormId = (formName) => {
  return useQuery([QK.formName, formName], () => getFormId(formName), {
    enabled: !!formName, 
  });
};